import React, { useState } from 'react';
import axios from 'axios';
import { Customer_api } from '../../../Apiconfig';
import style from './Addcustomer.module.css';
import { showCustomAlert } from '../../../customAlert';

const AddCustomerForm = () => {
  const [customerName, setCustomerName] = useState('');
  const [aadhar, setAadhar] = useState('');
  const [contact, setContact] = useState('');
  const [customerAddress, setCustomerAddress] = useState('');
  const [city, setCity] = useState('');
  const [pincode, setPincode] = useState('');
  const [aadharImage, setAadharImage] = useState(null);
  const [showForm, setShowForm] = useState(false);

  // Handle file input
  const handleFileChange = (e) => {
    setAadharImage(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Use FormData to handle text fields and file uploads
    const formData = new FormData();
    formData.append('customer_name', customerName);
    formData.append('aadhar', aadhar);
    formData.append('contact', contact);
    formData.append('customer_address', customerAddress);
    formData.append('city', city);
    formData.append('pincode', pincode);
    formData.append('aadhar_image', aadharImage); // Add the file

    try {
      const response = await axios.post(`${Customer_api}Add_customer.php`, formData, {
        withCredentials: true,
        headers: { 'Content-Type': 'multipart/form-data' },
      });

     showCustomAlert('Customer added successfully:');
      setCustomerName('');
      setAadhar('');
      setContact('');
      setCustomerAddress('');
      setCity('');
      setPincode('');
      setAadharImage(null);
      setShowForm(false); // Hide form after submission
    } catch (error) {
      showCustomAlert('There was an error adding the customer:', error);
    }
  };
 
  return (
    <div>
      {/* Button to show the form */}

      <button className={style.addcustomerbutton}
       
        onClick={() => setShowForm(true)}>Add Customer
        </button>

      {/* Show the form if showForm state is true */}
      {showForm && (
        <div className={style.forminputcard}>
          <form onSubmit={handleSubmit} encType="multipart/form-data" className={style.customercard}>
          <h2>ADD CUSTOMER</h2>
            <input
              type="text"
              name="customer_name"
              placeholder="Customer Name"
              value={customerName}
              onChange={(e) => setCustomerName(e.target.value)}
              required
            />
            <input
              type="text"
              name="aadhar"
              placeholder="Aadhar Number"
              value={aadhar}
              onChange={(e) => setAadhar(e.target.value)}
              required
            />
            <label>
              Upload Aadhar Card Image:
              <input
                type="file"
                name="aadhar_image"
                accept="image/*"
                onChange={handleFileChange}
                required
              />
            </label>
            <input
              type="tel"
              name="contact"
              placeholder="Contact Number"
              value={contact}
              onChange={(e) => setContact(e.target.value)}
              required
            />
            <input
              type="text"
              name="customer_address"
              placeholder="Customer Address"
              value={customerAddress}
              onChange={(e) => setCustomerAddress(e.target.value)}
              required
            />
            <input
              type="text"
              name="city"
              placeholder="City"
              value={city}
              onChange={(e) => setCity(e.target.value)}
              required
            />
            <input
              type="text"
              name="pincode"
              placeholder="Pincode"
              value={pincode}
              onChange={(e) => setPincode(e.target.value)}
              required
            />
            <button className={style.savebutton_customer} type="submit">Save Customer</button>
            <button className={style.closebutton_customer}  onClick={() => setShowForm(false)}>Close</button>
          </form>
       
        </div>
      )}
    </div>
  );
};

export default AddCustomerForm;
